import React from 'react';
import { motion } from 'framer-motion';
interface TrustBadgeProps {
  icon: React.ReactNode;
  label: string;
  description?: string;
}
export function TrustBadge({
  icon,
  label,
  description
}: TrustBadgeProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className="flex flex-col items-center text-center p-6 bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-244">
      <div className="p-3 bg-teal-50 text-teal-600 rounded-full mb-4" data-id="element-245">
        {icon}
      </div>
      <h3 className="font-semibold text-slate-900 mb-1" data-id="element-246">{label}</h3>
      {description && <p className="text-sm text-slate-500" data-id="element-247">{description}</p>}
    </motion.div>;
}